import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
};

export const chipWrapper: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  minWidth: 0,
  overflow: 'hidden',
};
